import moment from 'moment'
import React, { useEffect, useState } from 'react'
import {
  Button,
  ButtonGroup,
  Dropdown,
  DropdownButton,
  Offcanvas,
  Table
} from 'react-bootstrap'
import ReactPaginate from 'react-paginate'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import Select from 'react-select'
import Swal from 'sweetalert2'
import { useImmer } from 'use-immer'
import HKBadge from '../../../components/Badges'
import Loader from '../../../components/Loader'
import SearchBox from '../../../components/Searchbox'
import CustomToast from '../../../components/Toast/CustomToast'
import { customStyles } from '../../../components/customStyles'
import {
  calculatePageRange,
  encodeId,
  encodedSearchText,
  showToast
} from '../../../lib/AllGlobalFunction'
import {
  allCrudNames,
  allPages,
  checkPageAccess
} from '../../../lib/AllPageNames'
import { pageRangeDisplayed } from '../../../lib/AllStaticVariables'
import axiosProvider from '../../../lib/AxiosProvider'
import { _SwalDelete, _exception } from '../../../lib/exceptionMessage'
import useDebounce from '../../../lib/useDebounce'
import { setPageTitle } from '../../redux/slice/pageTitleSlice'
import BasicInfoModal from './BasicInfoModal'
import CreateSellerModal from './CreateSellerModal'
import GSTInfo from './GSTInfo'
import GSTReport from './GSTReport'
import SellerReport from './SellerReport'
import WarehouseModal from './WarehouseModal'

const AddSeller = () => {
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState()
  const [searchText, setSearchText] = useState('')
  const navigate = useNavigate()
  const isModalRequired = false
  const location = useLocation()
  const { userInfo } = useSelector((state) => state?.user)
  const { pageAccess } = useSelector((state) => state.user)
  const debounceSearchText = useDebounce(searchText, 500)
  const initValues = {
    createSeller: {
      firstName: '',
      lastName: '',
      emailID: '',
      mobileNo: '',
      password: '',
      gstNo: '',
      kycFor: '',
      cpass: '',
      newPasswordVisible: false,
      confirmPasswordVisible: false
    },
    basicInfo: {
      userID: '',
      kycFor: '',
      displayName: '',
      ownerName: '',
      contactPersonName: '',
      contactPersonMobileNo: '',
      panCardNo: '',
      nameOnPanCard: '',
      dateOfBirth: '',
      aadharCardNo: '',
      isUserWithGST: true,
      typeOfCompany: '',
      companyRegistrationNo: '',
      bussinessType: '',
      msmeNo: '',
      accountNo: '',
      accountHolderName: '',
      bankName: '',
      accountType: '',
      ifscCode: '',
      logo: '',
      digitalSign: '',
      cancelCheque: '',
      panCardDoc: '',
      msmeDoc: '',
      aadharCardFrontDoc: '',
      aadharCardBackDoc: '',
      shipmentBy: '',
      shipmentChargesPaidBy: null,
      note: '',
      status: 'Pending'
    },
    gstInfo: {
      userID: '',
      gstNo: '',
      legalName: '',
      tradeName: '',
      gstType: '',
      gstDoc: '',
      registeredAddressLine1: '',
      registeredAddressLine2: '',
      registeredLandmark: '',
      registeredPincode: '',
      registeredStateId: '',
      registeredCityId: '',
      registeredCountryId: '',
      tcsNo: '',
      status: ''
    },
    warehouse: {
      userID: '',
      gstInfoId: null,
      name: '',
      contactPersonName: '',
      contactPersonMobileNo: '',
      addressLine1: '',
      addressLine2: '',
      landmark: '',
      pincode: '',
      countryId: '',
      stateId: '',
      cityId: '',
      status: ''
    }
  }

  const [initialValues, setInitialValues] = useState(initValues)

  const [modalShow, setModalShow] = useImmer({
    createSeller: false,
    basicInfo: false,
    gstInfo: false,
    warehouse: false,
    report: false,
    gstReport: false
  })

  const [filterDetails, setFilterDetails] = useImmer({
    pageSize: 50,
    pageIndex: 1,
    status: '',
    searchText: ''
  })

  const [toast, setToast] = useState({
    show: false,
    text: null,
    variation: null
  })

  const fetchData = async () => {
    try {
      setLoading(true)

      const response = await axiosProvider({
        method: 'GET',
        endpoint: 'SellerData/search',
        queryString: `?searchText=${encodedSearchText(
          filterDetails?.searchText
        )}&pageIndex=${filterDetails?.pageIndex}&pageSize=${
          filterDetails?.pageSize
        }&status=${filterDetails?.status}`
      })
      setLoading(false)
      if (response?.status === 200) {
        setData({
          ...response?.data,
          data: response?.data?.data?.map((item) => ({
            ...item,
            gstInfo: item?.gstInfoDetails
              ? JSON.parse(item?.gstInfoDetails)[0]
              : null,
            warehouseDetails: item?.warehouseDetails
              ? JSON.parse(item?.warehouseDetails)[0]
              : null
          }))
        })
      }
    } catch {
      setLoading(false)

      showToast(toast, setToast, {
        data: {
          message: _exception?.message,
          code: 204
        }
      })
    }
  }

  const handlePageClick = (event) => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
    setFilterDetails((draft) => {
      draft.pageIndex = event.selected + 1
    })
  }

  const handleSellerActive = async (values, endpoint = 'SellerData/Update') => {
    try {
      setLoading(true)
      const response = await axiosProvider({
        method: 'PUT',
        endpoint,
        data: values,
        userId: userInfo?.userId,
        location: location.pathname
      })
      setLoading(false)

      if (response?.status === 200) {
        fetchData()
      }
      showToast(toast, setToast, response)
    } catch {
      setLoading(false)
      showToast(toast, setToast, {
        data: {
          message: _exception?.message,
          code: 204
        }
      })
    }
  }

  const handleArchiveAndDelete = async (
    userId,
    endpoint = 'SellerData/archived'
  ) => {
    try {
      setLoading(true)

      const response = await axiosProvider({
        method: 'PUT',
        endpoint,
        queryString: `?userId=${userId}`,
        userId: userInfo?.userId,
        location: location.pathname
      })
      setLoading(false)

      if (response?.status === 200) {
        fetchData()
      }
      showToast(toast, setToast, response)
    } catch {
      setLoading(false)
      showToast(toast, setToast, {
        data: {
          message: _exception?.message,
          code: 204
        }
      })
    }
  }

  useEffect(() => {
    dispatch(setPageTitle('Manage Seller'))
  }, [])

  useEffect(() => {
    setFilterDetails((draft) => {
      draft.searchText = searchText
    })
  }, [debounceSearchText])

  useEffect(() => {
    fetchData()
  }, [filterDetails])

  return (
    <>
      <div className='d-flex align-items-center justify-content-between gap-3 mb-3'>
        <div className='d-flex gap-3'>
          <SearchBox
            placeholderText={'Search'}
            value={searchText}
            searchclassnamewrapper={'searchbox-wrapper'}
            onChange={(e) => {
              setSearchText(e?.target?.value)
            }}
          />

          <div className='d-flex align-items-center me-2'>
            <label className='me-1'>Show</label>
            <select
              styles={customStyles}
              name='dataget'
              className='form-select me-1'
              value={filterDetails?.pageSize}
              onChange={async (e) => {
                setFilterDetails((draft) => {
                  draft.pageSize = e?.target?.value
                  draft.pageIndex = 1
                })
              }}
            >
              <option value='10'>10</option>
              <option value='25'>25</option>
              <option value='50'>50</option>
              <option value='100'>100</option>
              <option value='200'>200</option>
              <option value='500'>500</option>
            </select>
          </div>

          <div className='d-flex align-items-center page-range'>
            {calculatePageRange({
              ...filterDetails,
              recordCount: data?.pagination?.recordCount ?? 0
            })}
          </div>
        </div>
        <div className='d-flex gap-3'>
          <div className='input-file-wrapper'>
            <Select
              styles={customStyles}
              menuPortalTarget={document.body}
              isClearable
              name='status'
              placeholder='Seller Status'
              options={[
                {
                  label: 'Active',
                  value: 'Active'
                },
                {
                  label: 'Archived',
                  value: 'Archived'
                },
                {
                  label: 'Inactive',
                  value: 'Inactive'
                }
              ]}
              onChange={async (e) => {
                if (e?.value) {
                  setFilterDetails((draft) => {
                    draft.pageSize = 10
                    draft.pageIndex = 1
                    draft.status = e?.value
                  })
                } else {
                  setFilterDetails((draft) => {
                    draft.pageSize = 10
                    draft.pageIndex = 1
                    draft.status = ''
                  })
                }
              }}
            />
          </div>
          {checkPageAccess(
            pageAccess,
            allPages?.manageSeller,
            allCrudNames?.write
          ) && (
            <Dropdown as={ButtonGroup}>
              <Button
                variant='warning'
                className='fw-600 d-flex align-items-center gap-2'
                onClick={() => {
                  setInitialValues(initValues)
                  setModalShow((draft) => {
                    draft.createSeller = true
                  })
                }}
              >
                <i className='m-icon m-icon--plusblack'></i>
                Create Seller
              </Button>
              <Dropdown.Toggle
                split
                variant='warning'
                id='dropdown-split-basic'
                type='button'
              />

              <Dropdown.Menu>
                <Dropdown.Item>
                  <span
                    onClick={() =>
                      setModalShow((draft) => {
                        draft.report = true
                      })
                    }
                  >
                    Seller Report
                  </span>
                </Dropdown.Item>
                <Dropdown.Item>
                  <span
                    onClick={() =>
                      setModalShow((draft) => {
                        draft.gstReport = true
                      })
                    }
                  >
                    GST Report
                  </span>
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          )}
        </div>
      </div>

      <div className={`${data?.data?.length > 6 ? 'table-responsive' : ''}`}>
        <Table className='align-middle table-list hr_table_seller'>
          <thead>
            <tr>
              <th>Seller Name</th>
              <th>Contact Details</th>
              <th className='text-center'>Date</th>
              <th className='text-center'>Seller Status</th>
              <th className='text-center'>KYC Status</th>
              <th className='text-center'>More</th>
            </tr>
          </thead>
          <tbody>
            {data?.data?.length > 0 ? (
              data?.data?.map((user) => (
                <tr key={user?.userId}>
                  <td>
                    <div>
                      <span
                        onClick={() => {
                          navigate(
                            `/manage-seller/seller-details/${encodeId(
                              user?.userId
                            )}`
                          )
                        }}
                        className='fw-600 cp text-link'
                      >
                        {user?.displayName
                          ? user?.displayName
                          : `${user?.firstName} ${user?.lastName}`}
                      </span>
                      <div className='d-flex align-items-center gap-2 pt-1 pb-1'>
                        <i className='m-icon m-icon--user'></i>
                        {user?.gstInfo?.GSTNo ?? '-'}
                      </div>
                    </div>
                  </td>
                  <td>
                    {/* {user.userName} */}
                    <div className='d-flex align-items-center gap-2 pt-1 pb-1'>
                      <i className='m-icon m-icon--msg'></i>
                      {user?.email ?? '-'}
                    </div>
                    <div className='d-flex align-items-center gap-2 pt-1 pb-1'>
                      <i className='m-icon m-icon--cell'></i>
                      {user?.phone ?? '-'}
                    </div>
                  </td>
                  <td className='text-center'>
                    {user?.createdAt && (
                      <p className='mb-0'>
                        <span className='text-muted'>Created: </span>{' '}
                        {moment(user?.createdAt).format('DD-MM-YYYY')}
                      </p>
                    )}

                    {user?.modifiedDate && (
                      <p className='mb-0'>
                        <span className='text-muted'>Modified: </span>{' '}
                        {moment(user?.modifiedDate).format('DD-MM-YYYY')}
                      </p>
                    )}
                  </td>
                  <td className='text-center'>
                    <HKBadge
                      badgesbgname={
                        user?.userStatus?.toLowerCase() === 'active' ||
                        user?.userStatus?.toLowerCase() === 'approved'
                          ? 'success'
                          : 'danger'
                      }
                      badgesTxtname={
                        user?.userStatus ? user?.userStatus : 'Pending'
                      }
                      badgeClassname={'mb-2'}
                    />
                  </td>
                  <td className='text-center'>
                    <HKBadge
                      badgesbgname={
                        user?.kycStatus?.toLowerCase() === 'active' ||
                        user?.kycStatus?.toLowerCase() === 'approved'
                          ? 'success'
                          : 'danger'
                      }
                      badgesTxtname={
                        user?.kycStatus ? user?.kycStatus : 'Pending'
                      }
                      badgeClassname={'mb-2'}
                    />
                  </td>
                  <td className='text-center'>
                    <DropdownButton
                      align='end'
                      // className="d-none"
                      title={<i className='m-icon m-icon--dots'></i>}
                      id={`dropdown-menu-align-end ${user?.userId}`}
                      className='custom_dropdown'
                      type='button'
                    >
                      {checkPageAccess(
                        pageAccess,
                        allPages?.manageSeller,
                        allCrudNames?.update
                      ) && (
                        <Dropdown.Item
                          eventKey='1'
                          onClick={async () => {
                            try {
                              setLoading(true)
                              const response = await axiosProvider({
                                method: 'GET',
                                endpoint: `seller/KYC/byUserId?userId=${user?.userId}`
                              })
                              setLoading(false)
                              if (response?.status === 200) {
                                let basicInfo = !Array.isArray(
                                  response?.data?.data
                                )
                                  ? response?.data?.data
                                  : {
                                      ...initialValues?.basicInfo,
                                      userID: user?.userId
                                    }

                                setInitialValues({
                                  ...initialValues,
                                  basicInfo
                                })
                                setModalShow((draft) => {
                                  draft.basicInfo = true
                                })
                              }
                            } catch {
                              showToast(toast, setToast, {
                                data: {
                                  message: _exception?.message,
                                  code: 204
                                }
                              })
                            }
                          }}
                        >
                          Update seller KYC
                        </Dropdown.Item>
                      )}
                      {checkPageAccess(
                        pageAccess,
                        allPages?.manageSeller,
                        allCrudNames?.update
                      ) && (
                        <Dropdown.Item
                          eventKey='2'
                          onClick={async () => {
                            try {
                              setLoading(true)
                              const response = await axiosProvider({
                                method: 'GET',
                                endpoint: `seller/GSTInfo/byUserId?userId=${user?.userId}`
                              })
                              setLoading(false)
                              if (response?.status === 200) {
                                let apiResponse = response?.data?.data
                                let gstInfo
                                if (Array.isArray(apiResponse)) {
                                  if (apiResponse?.length === 0) {
                                    gstInfo = {
                                      ...initialValues?.gstInfo,
                                      userID: user?.userId
                                    }
                                  } else {
                                    gstInfo = apiResponse
                                  }
                                } else if (
                                  typeof apiResponse === 'object' &&
                                  apiResponse !== null
                                ) {
                                  gstInfo = apiResponse
                                } else {
                                  gstInfo = {
                                    ...initialValues?.gstInfo,
                                    userID: user?.userId
                                  }
                                }
                                setInitialValues({
                                  ...initialValues,
                                  gstInfo
                                })
                                setModalShow((draft) => {
                                  draft.gstInfo = true
                                })
                              }
                            } catch {
                              showToast(toast, setToast, {
                                data: {
                                  message: _exception?.message,
                                  code: 204
                                }
                              })
                            }
                          }}
                        >
                          Manage Tax
                        </Dropdown.Item>
                      )}
                      {checkPageAccess(
                        pageAccess,
                        allPages?.manageSeller,
                        allCrudNames?.update
                      ) && (
                        <Dropdown.Item
                          eventKey='3'
                          onClick={async () => {
                            try {
                              setLoading(true)
                              const response = await axiosProvider({
                                method: 'GET',
                                endpoint: `seller/Warehouse/WarehouseSearch?UserID=${user?.userId}`
                              })
                              setLoading(false)
                              if (response?.status === 200) {
                                let apiResponse = response?.data?.data
                                let warehouse
                                if (Array.isArray(apiResponse)) {
                                  if (apiResponse?.length === 0) {
                                    warehouse = {
                                      ...initialValues?.warehouse,
                                      userID: user?.userId
                                    }
                                  } else {
                                    warehouse = apiResponse
                                  }
                                } else if (
                                  typeof apiResponse === 'object' &&
                                  apiResponse !== null
                                ) {
                                  warehouse = apiResponse
                                } else {
                                  warehouse = {
                                    ...initialValues?.warehouse,
                                    userID: user?.userId
                                  }
                                }
                                setInitialValues({
                                  ...initialValues,
                                  warehouse
                                })
                                setModalShow((draft) => {
                                  draft.warehouse = true
                                })
                              }
                            } catch {
                              showToast(toast, setToast, {
                                data: {
                                  message: _exception?.message,
                                  code: 204
                                }
                              })
                            }
                          }}
                        >
                          Manage Pickup Address
                        </Dropdown.Item>
                      )}
                      <Dropdown.Item
                        eventKey='4'
                        onClick={() => {
                          navigate(
                            `/manage-seller/seller-details/${encodeId(
                              user?.userId
                            )}`
                          )
                        }}
                      >
                        View Seller Details
                      </Dropdown.Item>
                      {checkPageAccess(
                        pageAccess,
                        allPages?.manageSeller,
                        allCrudNames?.update
                      ) && (
                        <Dropdown.Item
                          onClick={async () => {
                            try {
                              setLoading(true)
                              const response = await axiosProvider({
                                method: 'GET',
                                endpoint: `SellerData/byId?id=${user?.userId}`
                              })
                              setLoading(false)
                              if (response?.status === 200) {
                                setInitialValues({
                                  ...initialValues,
                                  createSeller: response?.data?.data
                                })
                                setModalShow((draft) => {
                                  draft.createSeller = true
                                })
                              }
                            } catch {
                              showToast(toast, setToast, {
                                data: {
                                  message: _exception?.message,
                                  code: 204
                                }
                              })
                            }
                          }}
                        >
                          Edit Profile
                        </Dropdown.Item>
                      )}

                      {/* <Dropdown.Item eventKey="6">
                        Get Feed back sms
                      </Dropdown.Item>
                      <Dropdown.Item eventKey='7'>
                        Send SMS and Email
                      </Dropdown.Item>
                      <Dropdown.Item eventKey="8">Send KYC Link</Dropdown.Item> */}
                      {checkPageAccess(
                        pageAccess,
                        allPages?.manageSeller,
                        allCrudNames?.delete
                      ) && user?.sellerStatus?.toLowerCase() === 'active' ? (
                        <Dropdown.Item
                          eventKey='9'
                          onClick={() => {
                            Swal.fire({
                              title: 'Are you sure you want to Archive?',
                              text: _SwalDelete.text,
                              icon: _SwalDelete.icon,
                              showCancelButton: _SwalDelete.showCancelButton,
                              confirmButtonColor:
                                _SwalDelete.confirmButtonColor,
                              cancelButtonColor: _SwalDelete.cancelButtonColor,
                              confirmButtonText: 'Yes',
                              cancelButtonText: _SwalDelete.cancelButtonText
                            }).then((result) => {
                              if (result.isConfirmed) {
                                handleArchiveAndDelete(user?.userId)
                              } else if (result.isDenied) {
                              }
                            })
                          }}
                        >
                          Archive
                        </Dropdown.Item>
                      ) : (
                        checkPageAccess(
                          pageAccess,
                          allPages?.manageSeller,
                          allCrudNames?.update
                        ) && (
                          <Dropdown.Item
                            eventKey='9'
                            onClick={() => {
                              Swal.fire({
                                title: `Are you sure you want to Active ${
                                  user?.displayName
                                    ? user?.displayName
                                    : user?.fullName
                                }?`,
                                text: _SwalDelete.text,
                                icon: _SwalDelete.icon,
                                showCancelButton: _SwalDelete.showCancelButton,
                                confirmButtonColor:
                                  _SwalDelete.confirmButtonColor,
                                cancelButtonColor:
                                  _SwalDelete.cancelButtonColor,
                                confirmButtonText: 'Yes',
                                cancelButtonText: _SwalDelete.cancelButtonText
                              }).then((result) => {
                                if (result.isConfirmed) {
                                  handleSellerActive({
                                    id: user?.userId,
                                    firstName: user?.firstName,
                                    lastName: user?.lastName,
                                    userName: user?.email,
                                    email: user?.email,
                                    mobileNo: user?.phone,
                                    profileImage: null,
                                    status: 'Active',
                                    isEmailConfirmed: false,
                                    isPhoneConfirmed: false,
                                    roleTypeId: null,
                                    roleType: null
                                  })
                                } else if (result.isDenied) {
                                }
                              })
                            }}
                          >
                            Active
                          </Dropdown.Item>
                        )
                      )}
                      {checkPageAccess(
                        pageAccess,
                        allPages?.manageSeller,
                        allCrudNames?.delete
                      ) &&
                        !user?.status && (
                          <Dropdown.Item
                            eventKey='10'
                            onClick={() => {
                              Swal.fire({
                                title: _SwalDelete.title,
                                text: _SwalDelete.text,
                                icon: _SwalDelete.icon,
                                showCancelButton: _SwalDelete.showCancelButton,
                                confirmButtonColor:
                                  _SwalDelete.confirmButtonColor,
                                cancelButtonColor:
                                  _SwalDelete.cancelButtonColor,
                                confirmButtonText:
                                  _SwalDelete.confirmButtonText,
                                cancelButtonText: _SwalDelete.cancelButtonText
                              }).then((result) => {
                                if (result.isConfirmed) {
                                  handleArchiveAndDelete(
                                    user?.userId,
                                    'SellerData/delete'
                                  )
                                } else if (result.isDenied) {
                                }
                              })
                            }}
                          >
                            Delete
                          </Dropdown.Item>
                        )}
                    </DropdownButton>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={5} className='text-center fw-600'>
                  {data?.message}
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>

      {data?.pagination?.pageCount > 0 && (
        <ReactPaginate
          className='list-inline m-cst--pagination d-flex justify-content-end gap-1'
          breakLabel='...'
          nextLabel=''
          onPageChange={handlePageClick}
          pageRangeDisplayed={pageRangeDisplayed}
          pageCount={data?.pagination?.pageCount}
          previousLabel=''
          renderOnZeroPageCount={null}
          forcePage={filterDetails?.pageIndex - 1}
        />
      )}

      {loading && <Loader />}

      {isModalRequired ? (
        <>
          {modalShow?.createSeller && (
            <CreateSellerModal
              loading={loading}
              setLoading={setLoading}
              initialValues={initialValues}
              setInitialValues={setInitialValues}
              modalShow={modalShow}
              setModalShow={setModalShow}
              isModalRequired={isModalRequired}
              fetchData={fetchData}
              initValues={initValues}
              toast={toast}
              setToast={setToast}
            />
          )}

          {modalShow?.basicInfo && (
            <BasicInfoModal
              loading={loading}
              setLoading={setLoading}
              initialValues={initialValues}
              setInitialValues={setInitialValues}
              modalShow={modalShow}
              setModalShow={setModalShow}
              isModalRequired={isModalRequired}
              fetchData={fetchData}
              initValues={initValues}
              toast={toast}
              setToast={setToast}
            />
          )}

          {modalShow?.gstInfo && (
            <GSTInfo
              loading={loading}
              setLoading={setLoading}
              initialValues={initialValues}
              setInitialValues={setInitialValues}
              modalShow={modalShow}
              setModalShow={setModalShow}
              isModalRequired={isModalRequired}
              fetchData={fetchData}
              initValues={initValues}
              toast={toast}
              setToast={setToast}
            />
          )}

          {modalShow?.warehouse && (
            <WarehouseModal
              loading={loading}
              setLoading={setLoading}
              initialValues={initialValues}
              setInitialValues={setInitialValues}
              modalShow={modalShow}
              setModalShow={setModalShow}
              isModalRequired={isModalRequired}
              fetchData={fetchData}
              initValues={initValues}
              toast={toast}
              setToast={setToast}
            />
          )}
        </>
      ) : (
        <>
          {modalShow?.createSeller ||
          modalShow?.basicInfo ||
          modalShow?.gstInfo ||
          modalShow?.warehouse ? (
            <Offcanvas
              className='pv-offcanvas'
              placement='end'
              show={
                modalShow?.createSeller ||
                modalShow?.basicInfo ||
                modalShow?.gstInfo ||
                modalShow?.warehouse
              }
              backdrop='static'
              onHide={() => {
                setInitialValues(initValues)
                setModalShow((draft) => {
                  draft.createSeller = false
                  draft.basicInfo = false
                  draft.gstInfo = false
                  draft.warehouse = false
                })
              }}
            >
              <Offcanvas.Header closeButton>
                <Offcanvas.Title className='bold'>
                  {modalShow?.createSeller
                    ? initialValues?.createSeller?.id
                      ? 'Update Seller'
                      : 'Create Seller'
                    : modalShow?.basicInfo
                    ? 'Basic Info'
                    : modalShow?.gstInfo
                    ? 'Tax Info'
                    : modalShow?.warehouse
                    ? 'Warehouse'
                    : ''}
                </Offcanvas.Title>
              </Offcanvas.Header>
              <Offcanvas.Body>
                {modalShow?.createSeller && (
                  <CreateSellerModal
                    loading={loading}
                    setLoading={setLoading}
                    initialValues={initialValues}
                    setInitialValues={setInitialValues}
                    modalShow={modalShow}
                    setModalShow={setModalShow}
                    isModalRequired={isModalRequired}
                    fetchData={fetchData}
                    initValues={initValues}
                    toast={toast}
                    setToast={setToast}
                  />
                )}

                {modalShow?.basicInfo && (
                  <BasicInfoModal
                    loading={loading}
                    setLoading={setLoading}
                    initialValues={initialValues}
                    setInitialValues={setInitialValues}
                    modalShow={modalShow}
                    setModalShow={setModalShow}
                    isModalRequired={isModalRequired}
                    fetchData={fetchData}
                    initValues={initValues}
                    toast={toast}
                    setToast={setToast}
                  />
                )}

                {modalShow?.gstInfo && (
                  <GSTInfo
                    loading={loading}
                    setLoading={setLoading}
                    initialValues={initialValues}
                    setInitialValues={setInitialValues}
                    modalShow={modalShow}
                    setModalShow={setModalShow}
                    isModalRequired={isModalRequired}
                    fetchData={fetchData}
                    initValues={initValues}
                    toast={toast}
                    setToast={setToast}
                  />
                )}

                {modalShow?.warehouse && (
                  <WarehouseModal
                    loading={loading}
                    setLoading={setLoading}
                    initialValues={initialValues}
                    setInitialValues={setInitialValues}
                    modalShow={modalShow}
                    setModalShow={setModalShow}
                    isModalRequired={isModalRequired}
                    fetchData={fetchData}
                    initValues={initValues}
                    toast={toast}
                    setToast={setToast}
                  />
                )}
              </Offcanvas.Body>
            </Offcanvas>
          ) : (
            <></>
          )}
        </>
      )}

      {modalShow?.report && (
        <SellerReport modalShow={modalShow} setModalShow={setModalShow} />
      )}

      {modalShow?.gstReport && (
        <GSTReport modalShow={modalShow} setModalShow={setModalShow} />
      )}

      {toast?.show && (
        <CustomToast text={toast?.text} variation={toast?.variation} />
      )}
    </>
  )
}

export default AddSeller
